import DealershipActions from './DealershipActions';

export default DealershipActions;
